module.exports = __webpack_public_path__ + "img/home1.b49dad83.png";